module.exports = __webpack_public_path__ + "img/gawedzki.4f24e8ea.jpg";